import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function Home() {
  const [expanded, setExpanded] = useState(false);
  const cardRef = useRef(null);
  const expandedRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!expanded || !cardRef.current || !expandedRef.current) {
      return;
    }

    const timer = setTimeout(() => {
      cardRef.current.scrollTo({
        top: expandedRef.current.offsetTop - 20,
        behavior: "smooth",
      });
    }, 200);

    return () => clearTimeout(timer);
  }, [expanded]);

  return (
    <div className="min-h-[100%] overflow-hidden bg-body">
      <section className="mt-6 flex justify-center px-4 sm:px-6 lg:mt-10">
        <div
          ref={cardRef}
          className={`relative w-full max-w-7xl rounded-2xl border border-neutral-border bg-neutral-white p-6 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-sm animate-[fadeInUp_0.6s_ease-out] sm:p-8 md:p-10 lg:p-12 ${
            expanded
              ? "max-h-[640px] overflow-y-auto"
              : "max-h-[580px] overflow-hidden md:max-h-[460px]"
          }`}
        >
          <span className="absolute left-0 top-6 h-12 w-1 rounded-r-full bg-primary sm:h-16" />

          <h1 className="text-center font-[Gagalin] text-2xl text-primary-default sm:text-3xl md:text-4xl">
            WealthGrow Fintax Services
          </h1>

          <p className="mx-auto mt-6 max-w-5xl text-center text-sm leading-relaxed text-neutral-textSecondary sm:text-base">
            <span className="font-medium text-primary-dark">
              WealthGrow Fintax Services (WFS)
            </span>{" "}
            is a professionally managed, multidisciplinary consultancy firm
            delivering integrated solutions across taxation, financial
            management, legal advisory, insurance, technology consulting, and
            engineering services. We serve individuals, startups, and
            established enterprises with a strong focus on regulatory
            compliance, financial discipline, and long-term value creation.
          </p>

          <p className="mx-auto mt-4 max-w-5xl text-center text-sm leading-relaxed text-neutral-textSecondary sm:text-base md:text-lg">
            With a network of experienced professionals and domain specialists,
            WFS operates with a deep understanding of India&apos;s regulatory,
            financial, and business environments. Our advisory approach combines
            technical expertise with practical insight, enabling clients to
            navigate complex regulations, mitigate risk, and make informed
            strategic decisions with confidence.
          </p>

          <div
            ref={expandedRef}
            className={`transition-opacity duration-300 ${
              expanded ? "mt-4 opacity-100" : "h-0 overflow-hidden opacity-0"
            }`}
          >
            <p className="mx-auto mt-4 max-w-5xl text-center text-sm leading-relaxed text-neutral-textSecondary sm:text-base md:text-lg">
              At WFS, we believe sustainable growth is built on accuracy,
              transparency, and responsible planning. Every engagement is
              approached with diligence and accountability, ensuring our clients
              receive reliable guidance aligned with statutory requirements and
              industry best practices.
            </p>

            <p className="mx-auto mt-4 max-w-5xl text-center text-sm leading-relaxed text-neutral-textSecondary sm:text-base md:text-lg">
              From tax planning and audits to financial structuring, legal
              compliance, and engineering consultancy, WFS functions as a
              single-window advisory partner. Our objective is not only to solve
              immediate challenges, but also to build long-term professional
              relationships grounded in trust, integrity, and measurable
              outcomes.
            </p>
          </div>

          <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row sm:gap-6 lg:mt-10 lg:gap-20">
            <button className="w-full rounded-lg bg-primary-default px-6 py-3 font-semibold text-accent-gold shadow transition-all 
            duration-300 hover:bg-primary-light hover:text-white hover:shadow-md sm:w-auto sm:px-8 lg:px-10"
            onClick={() => navigate("/contact")}>
              Let&apos;s Talk
            </button>
            <button
              onClick={() => setExpanded((prev) => !prev)}
              className="w-full rounded-lg border border-primary px-6 py-3 font-semibold text-primary transition-all duration-300 hover:bg-primary hover:text-accent-goldLight sm:w-auto sm:px-8 lg:px-10"
            >
              {expanded ? "Show Less" : "Learn More"}
            </button>
          </div>
        </div>
      </section>

      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(16px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}

export default Home;
